<template>
  <v-container>
    <div id="grid-acomodaciones">
      <v-layout>
        <v-flex
          xs6
          v-if="
            usuarioLoggedTipe == 'AGENCIA' ||
            usuarioLoggedTipe == 'ADMINISTRADOR'
          "
        >
          <v-btn color="primary" @click="descargaPlanillaBase()"
            >Descarga Plantilla Acomodaciones</v-btn
          >
        </v-flex>
        <v-flex xs4 grid-list-xl>
          <v-toolbar-title class="indigo--text"
            >Carga masiva Acomodación</v-toolbar-title
          >
          <data-adjunto
            :documentoId="id"
            :tipeView="tipeView"
            :tipeArchive="tipeArchive"
          ></data-adjunto>
        </v-flex>
        <v-flex xs1>
          <v-btn
            v-if="botonCargar == true"
            depressed
            :loading="loading1"
            outline
            icon
            fab
            dark
            color="primary"
            medium
            title="Cargar planilla"
            @click="validarArchivo()"
          >
            Validar
          </v-btn>
        </v-flex>
        <v-flex xs3>
          <v-btn
            v-if="botonProcesar == true"
            color="primary"
            :loading="loading1"
            dark
            class="mb-2"
            :disabled="desactivarUpload == true ? true : false"
            @click="cargaMasiva()"
          >
            Cargar
          </v-btn>
        </v-flex>
      </v-layout>

      <!-- <v-layout v-if="(usuarioLoggedTipe=='AGENCIA' || usuarioLoggedTipe=='ADMINISTRADOR')">
        <v-flex xs4 order-md1>
          <v-btn color="primary" @click="descargaPlanillaBase()">Descarga Plantilla Acomodaciones</v-btn>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs3 order-md4 class="mx-3">
          <v-btn
            depressed
            outline
            icon
            fab
            dark
            color="primary"
            medium
            title="Cargar planilla"
            :disabled="desactivarUpload == true ? true : false"
            @click="cargaMasiva()"
          >cargar</v-btn>
        </v-flex>
        <v-flex xs5 order-md3 grid-list-xl class="mx-2">
          <v-toolbar-title class="indigo--text">Carga masiva acomodaciones</v-toolbar-title>
          <data-adjunto :documentoId="id" :tipeView="tipeView" :tipeArchive="tipeArchive"></data-adjunto>
        </v-flex>
      </v-layout>  -->

      <v-layout justify-center>
        <v-flex xs12 md4>
          <v-select
            v-model="regionValue"
            :items="regionSelect"
            label="Region"
            item-text="name"
            item-value="code"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="comunaValue"
            :items="comunaSelect"
            label="Comuna"
            item-text="name"
            item-value="code"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="nivelValue"
            :items="nivelSelect"
            label="Nivel"
            item-text="name"
            item-value="code"
          ></v-select>
        </v-flex>
        <v-btn
          fab
          dark
          color="teal"
          title="Filtrar detalle"
          @click="filterAcomodaciones()"
        >
          <v-icon dark>filter_list</v-icon>
        </v-btn>
        <!-- BOTON NO INCLUIDO EN DISEÑO DEBERIA ESTAR -->
        <v-btn
          fab
          dark
          color="red darken-4"
          title="Limpiar filtros"
          @click="clear()"
        >
          <v-icon dark>clear_all</v-icon>
        </v-btn>
      </v-layout>
      <v-toolbar card color="white">
        <v-toolbar-title class="indigo--text"
          >Gestión Acomodaciones</v-toolbar-title
        >
      </v-toolbar>

      <v-layout justify-center>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div v-if="alerta">
            <alert-empty></alert-empty>
          </div>
          <v-spacer></v-spacer>
          <v-data-table
            :headers="headers"
            :items="itemsDocumento"
            :pagination.sync="miPaginacion"
            hide-actions
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td>{{ props.item.region.nombre }}</td>
              <td class="text-xs-left">{{ props.item.comuna.nombre }}</td>
              <td class="text-xs-left">{{ props.item.nivel.descripcion }}</td>
              <td>{{ props.item.rbd }}</td>
              <td class="text-xs-left">{{ props.item.letra }}</td>
              <td class="text-xs-left">
                {{ props.item.rutEstudiante + "-" + props.item.dvEstudiante }}
              </td>
              <td class="text-xs-left">{{ props.item.idDiscapacidad }}</td>
              <td class="text-xs-left">{{ props.item.idTipoDiscapacidad }}</td>
              <td>
                <v-btn
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="green darken-4"
                  small
                  title="Consultar Detalles"
                  @click="detalleAcomodacion(props.item.id)"
                >
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>

          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn
              class="btn-sigas"
              depressed
              outline
              icon
              fab
              dark
              color="green darken-4"
              small
            >
              <v-icon>remove_red_eye</v-icon> </v-btn
            >&nbsp;Consultar detalles
          </v-card-actions>
          <v-dialog v-model="dialogLoading" persistent max-width="390">
            <loading-descarga></loading-descarga>
          </v-dialog>
        </v-flex>
      </v-layout>
      <v-card-actions class="pb-3">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="descargaAcomodaciones()"
          >Descarga Masiva</v-btn
        >
        <v-btn color="primary" @click="descargaAlertas()"
          >Generar Validaciones
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
      <!-- PAGINACION -->
      <v-flex xs12 sm6>
        <v-text-field
          value=""
          label="Total de Registros"
          v-model="miPaginacion.totalItems"
          disabled
        ></v-text-field>
      </v-flex>
      <div class="pt-2">
        <v-pagination
          v-model="miPaginacion.page"
          :length="numPaginas"
          :total-visible="7"
          circle
        ></v-pagination>
      </div>
      <v-dialog v-model="dialogLoading" persistent max-width="390">
        <loading-descarga></loading-descarga>
      </v-dialog>
    </div>
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title class="headline" style="font-weight: bold"
          >Se encontraron los siguientes errores:</v-card-title
        >

        <v-card-title v-if="arrRut.length > 0" style="font-weight: bold"
          >Rut Incorrecto o el rut no se encuentra en la base de
          Alumnos:</v-card-title
        >
        <ul v-if="arrRut.length > 0">
          <li v-for="(rut, index) in arrRut" :key="index">{{ rut }}</li>
        </ul>
        <v-card-title v-if="arrDv.length > 0" style="font-weight: bold"
          >Los siguientes dígitos verificadores del rut no son
          correctos:</v-card-title
        >
        <ul v-if="arrDv.length > 0">
          <li v-for="(dv, index) in arrDv" :key="index">{{ dv }}</li>
        </ul>
        <v-card-title v-if="arrRegion.length > 0" style="font-weight: bold"
          >Los siguientes códigos de región son incorrectos:</v-card-title
        >
        <ul v-if="arrRegion.length > 0">
          <li v-for="(region, index) in arrRegion" :key="index">
            {{ region }}
          </li>
        </ul>
        <v-card-title v-if="arrComuna.length > 0" style="font-weight: bold"
          >Los siguientes códigos de comuna son incorrectos:</v-card-title
        >
        <ul v-if="arrComuna.length > 0">
          <li v-for="(comuna, index) in arrComuna" :key="index">
            {{ comuna }}
          </li>
        </ul>
        <v-card-title v-if="arrRBD.length > 0" style="font-weight: bold"
          >Los siguientes RBD son incorrectos:</v-card-title
        >
        <ul v-if="arrRBD.length > 0">
          <li v-for="(rbd, index) in arrRBD" :key="index">{{ rbd }}</li>
        </ul>
        <v-card-title v-if="arrCodigoCurso.length > 0" style="font-weight: bold"
          >Los siguientes códigos de curso son incorrectos:</v-card-title
        >
        <ul v-if="arrCodigoCurso.length > 0">
          <li v-for="(codigoCurso, index) in arrCodigoCurso" :key="index">
            {{ codigoCurso }}
          </li>
        </ul>
        <v-card-title v-if="arrNivel.length > 0" style="font-weight: bold"
          >Los siguientes id de nivel son incorrectos:</v-card-title
        >
        <ul v-if="arrNivel.length > 0">
          <li v-for="(nivel, index) in arrNivel" :key="index">{{ nivel }}</li>
        </ul>
        <v-card-title v-if="arrExaminador.length > 0" style="font-weight: bold"
          >Rut Examinador incorrecto o el rut no se encuentra en la base de
          examinadores válidos:</v-card-title
        >
        <ul v-if="arrExaminador.length > 0">
          <li v-for="(rutExaminador, index) in arrExaminador" :key="index">
            {{ rutExaminador }}
          </li>
        </ul>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="indigo darken-1" flat="flat" @click="dialog = false"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogArchivo" persistent max-width="600">
      <v-card>
        <v-card-title class="headline">Resumen de Archivo </v-card-title>
        <v-card-text>
          <v-flex lg12>
            <v-spacer></v-spacer>
            <v-card-actions class="pb-3">
              <v-spacer></v-spacer>
            </v-card-actions>

            <p v-if="respOk == false">{{ this.resp }}</p>
            <div class="text-resp" v-if="respOk == true">
              <v-icon class="ico-resp">check_circle</v-icon>
              <p>Archivo sin errores!</p>
            </div>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="closeModal()"
            >Aceptar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import axios from "axios";
import DataAdjunto from "@/components/AdjuntoData.vue";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";

export default {
  name: "grid-acomodaciones",

  components: {
    DataAdjunto,
    LoadingDescarga,
    Loading,
    AlertEmpty,
  },
  props: {
    rowsTable: String,
    tipeView: String,
  },

  data() {
    return {
      miPaginacion: {
        rowsPerPage: 20,
        page: 0,
      },
      arrDv: [],
      arrRut: [],
      arrRegion: [],
      arrComuna: [],
      arrRBD: [],
      arrCodigoCurso: [],
      arrNivel: [],
      arrExaminador: [],
      dialog: false,
      dialogLoading: false,
      loading: false,
      desactivarUpload: false,
      usuarioLoggedTipe: "",
      dialog: false,
      alerta: false,
      id: "",
      idContrato: "",
      headers: [
        { text: "Región", align: "left", sortable: false, value: "region" },
        { text: "Comuna", sortable: false, value: "comuna" },
        { text: "Nivel", sortable: false, value: "nivel" },
        { text: "RBD", sortable: false, value: "rbd" },
        { text: "Letra", sortable: false, value: "letra" },
        { text: "Rut Estudiante", sortable: false, value: "rutEstudiante" },
        { text: "ID Discapacidad", sortable: false, value: "idDiscapacidad" },
        { text: "Discapacidad", sortable: false, value: "Discapacidad" },
        { text: "Accion", sortable: false, value: "" },
      ],
      bloqueo: Boolean,
      itemsDocumento: [],
      proceso: "",
      tipeArchive: "",
      regionValue: null,
      regionSelect: [],
      comunaValue: null,
      comunaSelect: [],
      nivelValue: null,
      nivelSelect: [],
      filter: false,
      botonCargar: true,
      botonProcesar: false,
      dialogArchivo: false,
      respOk: false,
      resp: "",
      loading1: false,
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 4000);
    },
  },
  created() {
    this.idContrato = this.$store.getters.contratoStored;
    this.proceso = this.$store.getters.proSelectedStored;
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.tipeArchive = ".xlsx";
    this.loadData();
  },

  mounted() {},
  computed: {
    numPaginas() {
      if (
        this.miPaginacion.rowsPerPage == null ||
        this.miPaginacion.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.miPaginacion.totalItems / this.miPaginacion.rowsPerPage
      );
    },
  },
  methods: {
    async loadAcomodacionesFilter() {
      let proceso = this.$store.getters.proSelectedStored;
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        idRegion:
          this.regionValue && this.regionValue != null
            ? this.regionValue
            : null,
        idComuna:
          this.comunaValue && this.comunaValue != null
            ? this.comunaValue
            : null,
        idNivel:
          this.nivelValue && this.nivelValue != null ? this.nivelValue : null,

        proceso: proceso,
        idContrato: idContrato,
      };
      return await axios

        .post("/acomodaciones/filter", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },

    async loadData() {
      this.loading = true;
      this.itemsDocumento = await this.loadAcomodacionesFilter();
      this.miPaginacion.totalItems = this.itemsDocumento.length;
      this.loading = false;
      if (this.itemsDocumento.length > 0) {
        this.loadRegionSelect();
        this.loadComunaSelect();
        this.loadNivelSelect();
      }
    },

    loadComunaSelect() {
      let reg = [];
      this.itemsDocumento.forEach(function (d) {
        if (d.comuna != null) {
          let index = reg.findIndex((x) => x.code == d.comuna.id);
          if (index === -1) {
            if (d.comuna != null && d.comuna != "") {
              reg.push({
                name: d.comuna.nombre,
                code: d.comuna.id,
              });
            }
          }
        }
      });
      this.comunaSelect = reg;
    },
    loadNivelSelect() {
      let reg = [];
      this.itemsDocumento.forEach(function (d) {
        if (d.nivel != null) {
          let index = reg.findIndex((x) => x.code == d.nivel.id);
          if (index === -1) {
            if (d.nivel != null && d.nivel != "") {
              reg.push({
                name: d.nivel.descripcion,
                code: d.nivel.codNivelAce,
              });
            }
          }
        }
      });
      this.nivelSelect = reg;
    },
    loadRegionSelect() {
      let reg = [];
      this.itemsDocumento.forEach(function (d) {
        if (d.comuna.idRegion != null) {
          let index = reg.findIndex((x) => x.code == d.region.id);
          if (index === -1) {
            if (d.region != null && d.region != "") {
              reg.push({
                name: d.region.nombre,
                code: d.region.id,
              });
            }
          }
        }
      });
      this.regionSelect = reg;
    },

    clear() {
      this.regionValue = "";
      this.comunaValue = "";
      this.nivelValue = "";
      this.loadData();
    },
    filterAcomodaciones() {
      this.filter = true;
      this.loadData();
    },
    detalleAcomodacion(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "FormAcomodaciones",
          params: { idAcomodacion: id, tipeView: "consulta" },
        });
      }, 1000);
    },
    descargaAcomodaciones() {
      this.dialogLoading = true;
      axios
        .get("/acomodaciones/downloadReporte/" + this.idContrato, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", "DESCARGA_ACOMODACIONES.xlsx");
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    descargaAlertas() {
      this.dialogLoading = true;
      axios
        .get("/acomodaciones/writeExcelAcomodaAlertas/" + this.idContrato, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", "DESCARGA_ALERTAS.xlsx");
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    descargaPlanillaBase() {
      this.dialogLoading = true;
      axios
        .get("/acomodaciones/download/" + this.idContrato, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", "PLANILLA_ACOMODACIONES.xlsx");
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    reload() {
      setTimeout(() => {
        this.$parent.reloadDocumento();
        // this.$router.go(-1)
      }, 1000);
    },

    respIsEmpty(mapArchivo) {
      for (var key in mapArchivo) {
        if (mapArchivo.hasOwnProperty(key)) return false;
      }
      return true;
    },
    closeModal() {
      this.dialogArchivo = false;
      let resp = this.resp;
      if (resp) {
        this.botonProcesar = true;
        this.botonCargar = false;
      } else {
        this.botonProcesar = false;
        this.botonCargar = true;
      }
    },
    async validarArchivo() {
      this.loading1 = true;
      this.resp = await this.preProcessFile();
      let respuesta = this.resp;
      console.log(respuesta);
      if (respuesta == undefined) {
        console.log(respuesta);
      } else {
        let resp = this.resp;
        if (resp) {
          this.respOk = true;
        } else {
          this.rutNoValid = respuesta;
        }
        this.dialogArchivo = true;
      }

      this.loading1 = false;
    },
    async preProcessFile() {
      let base64EncodedStr = this.base64Value;
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        documento: base64EncodedStr,
        idContrato: idContrato,
      };
      return await axios
        .post("/acomodaciones/preProcessFile", this.body)
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
        });
    },
    processFile() {
      this.desactivarUpload = true;
      this.loading = true;
      let base64EncodedStr = this.base64Value;
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        documento: base64EncodedStr,
        idContrato: idContrato,
      };
      axios
        .post("/acomodaciones/readFile", this.body)
        .then((response) => {
          this.resp = response.data;
          if (
            this.resp.dvErrors.length > 0 ||
            this.resp.regionErrors.length > 0 ||
            this.resp.comunaErrors.length > 0 ||
            this.resp.rutIncorrectos.length > 0 ||
            this.resp.rbdErrors.length > 0 ||
            this.resp.codigoCursoErrors.length > 0 ||
            this.resp.nivelErrors.length > 0 ||
            this.resp.examinadorErrors.length > 0
          ) {
            this.arrDv = this.resp.dvErrors;
            this.arrRut = this.resp.rutIncorrectos;
            this.arrRegion = this.resp.regionErrors;
            this.arrComuna = this.resp.comunaErrors;
            this.arrRBD = this.resp.rbdErrors;
            this.arrCodigoCurso = this.resp.codigoCursoErrors;
            this.arrNivel = this.resp.nivelErrors;
            this.arrExaminador = this.resp.examinadorErrors;
            this.dialog = true;
            this.loadData();
            this.loading = false;
            this.desactivarUpload = false;
          } else {
            this.cargaMasiva();
          }
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
            this.loadData();
            this.loading = false;
            this.desactivarUpload = false;
          }
        });
    },
    async procesarCarga() {
      this.loading1 = true;
      this.resp = await this.procesarArchivo();
      this.loading1 = false;
      //this.reload();
    },
    procesarArchivo() {
      let base64EncodedStr = this.base64Value;
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        documento: base64EncodedStr,
        idContrato: idContrato,
      };
      axios
        .post("/acomodaciones/cargaMasiva", this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_SAVE");
          this.reload();
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
            this.reload();
          }
        });
    },
    cargaMasiva() {
      this.desactivarUpload = true;
      this.loading = true;
      let base64EncodedStr = this.base64Value;
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        documento: base64EncodedStr,
        idContrato: idContrato,
      };
      axios
        .post("/acomodaciones/cargaMasiva", this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_SAVE");
          this.loadData();
          this.loading = false;
          this.desactivarUpload = false;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
            this.loadData();
            this.loading = false;
            this.desactivarUpload = false;
          }
        });
    },
  },
};
</script>
